import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/auth-guard.guard';
import { IsloggedGuard } from './core/islogged-guard.guard';

const routes: Routes = [
  //Little Component

  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'login',
    canActivate: [IsloggedGuard],
    loadChildren: () => import('./pages/auth/login.module').then(m => m.LoginModule)
  },
  {
    path: 'notaccess',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/not-access/not-access.module').then(m => m.NotAccessModule)
  },
  {
    path: 'reports',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reports/report.module').then(m => m.ReportModule)
  },
  {
    path: 'sale-orders',
    canActivate: [AuthGuard], // Asegúrate que el guard no esté bloqueando
    loadChildren: () => import('./pages/sale-orders/sale-orders.module').then(m => m.SaleOrdersModule),
    data: { preload: true } // Opcional para mejor performance
  },
  {
    path: 'sale-orders-scheduler',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/sale-orders/components/sale-orders-scheduler/sale-orders-scheduler.module').then(m => m.SaleOrdersSchedulerModule)
  },
  {
    path: 'hardware-production',
    loadChildren: () => import('./pages/hardware-production/hardware-production.module').then(m => m.HardwareProductionModule)
  },
  { path: 'exchange-rates', loadChildren: () => import('./pages/exchange-rates/exchange-rates.module').then(m => m.ExchangeRatesModule) },
  { path: 'customers', loadChildren: () => import('./pages/customers/customers.module').then(m => m.CustomersModule) },
  { path: 'suppliers', loadChildren: () => import('./pages/suppliers/suppliers.module').then(m => m.SuppliersModule) },
  { path: 'banks', canActivate: [AuthGuard], loadChildren: () => import('./pages/banks/banks.module').then(m => m.BanksModule) },
  { path: 'hardware', canActivate: [AuthGuard], loadChildren: () => import('./pages/hardware/hardware.module').then(m => m.HardwareModule) },
  { path: 'materials', canActivate: [AuthGuard], loadChildren: () => import('./pages/materials/materials.module').then(m => m.MaterialsModule) },
  { path: 'administration', loadChildren: () => import('./pages/administration/administration.module').then(m => m.AdministrationModule) },
  { path: 'invoice', loadChildren: () => import('./pages/invoice/invoice.module').then(m => m.InvoiceModule) },
  {
    path: '**',
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
